import { render, staticRenderFns } from "./AddPlacesPage.vue?vue&type=template&id=5a22e782&scoped=true&"
import script from "./AddPlacesPage.vue?vue&type=script&lang=js&"
export * from "./AddPlacesPage.vue?vue&type=script&lang=js&"
import style0 from "./AddPlacesPage.vue?vue&type=style&index=0&id=5a22e782&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a22e782",
  null
  
)

export default component.exports